export const staffMenuItems = [
    {
        label: "menuitems.menu.text",
        isTitle: true
    },
    {
        label: 'menuitems.dashboard.text',
        icon: 'ri-dashboard-line',
        badge: {
            variant: "success",
            text: "menuitems.dashboard.badge"
        },
        link: '/'
    },
    {
        label: 'menuitems.booking.text',
        icon: 'ri-order-play-fill',
        link: '/booking'
    },
    // {
    //     label: 'menuitems.redeem.text',
    //     icon: 'ri-award-line',
    //     link: '/redeem'
    // },
    {
        label: 'menuitems.setting.list.staff_block_date',
        link: '/setting/staff-block-date',
        icon: 'ri-calendar-line',
    },
]